var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dialog-scroll-lock', {
    attrs: {
      "width": "420",
      "content-class": "relative contain-none overflow-visible",
      "value": _vm.value
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [_c('error-dialog', {
    attrs: {
      "status": _vm.loadExistingResponseStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.saveStatus
    }
  }), _c('sign-in-dialog', {
    attrs: {
      "hide-subscribe": ""
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        var _vm$verified;
        return [_vm._v(" Verify your email address"), (_vm$verified = _vm.verified) !== null && _vm$verified !== void 0 && _vm$verified.startsWith('+') ? [_vm._v(" / phone number")] : _vm._e()];
      },
      proxy: true
    }, {
      key: "subtitle",
      fn: function () {
        var _vm$verified2;
        return [_vm._v(" The host has requested that all responses come from verified email addresses"), (_vm$verified2 = _vm.verified) !== null && _vm$verified2 !== void 0 && _vm$verified2.startsWith('+') ? [_vm._v(". You can also continue using the phone number to which this invitation was originally sent.")] : _vm._e(), _vm.verified ? [_c('br'), _c('br'), _c('v-btn', {
          staticClass: "btn-like-google-sign-in primary white--text elevation-2",
          attrs: {
            "outlined": ""
          },
          on: {
            "click": function ($event) {
              _vm.target = _vm.verified;
            }
          }
        }, [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiArrowRightBoldCircle)
          }
        }), _vm._v(" Continue with " + _vm._s(_vm._f("email-phone")(_vm.verified)) + " ")], 1)] : _vm._e()];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showVerify,
      callback: function ($$v) {
        _vm.showVerify = $$v;
      },
      expression: "showVerify"
    }
  }), _vm.showGuestList ? _c('public-guest-list-dialog', {
    attrs: {
      "form": _vm.event.form,
      "guests": _vm.guestList
    },
    model: {
      value: _vm.showGuestList,
      callback: function ($$v) {
        _vm.showGuestList = $$v;
      },
      expression: "showGuestList"
    }
  }) : _vm._e(), _vm.showAddToCalendar ? _c('add-to-calendar-dialog', {
    attrs: {
      "event": _vm.event
    },
    model: {
      value: _vm.showAddToCalendar,
      callback: function ($$v) {
        _vm.showAddToCalendar = $$v;
      },
      expression: "showAddToCalendar"
    }
  }) : _vm._e(), _vm.isSample ? _c('v-btn', {
    staticStyle: {
      "z-index": "1",
      "top": "-12px",
      "left": "-12px",
      "width": "unset"
    },
    attrs: {
      "absolute": "",
      "rounded": "",
      "large": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('edit-event');
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiCalendarEdit)
    }
  }), _vm._v(" Edit event… ")], 1) : _vm._e(), _c('v-card', {
    staticClass: "py-5 subtitle overflow-auto",
    staticStyle: {
      "max-height": "calc(100svh - 48px) !important"
    }
  }, [_c('v-btn', {
    staticClass: "float-right ma-3 mt-n2",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1), _c('event-summary', {
    staticClass: "pt-5 pb-9 px-6",
    attrs: {
      "event": _vm.event,
      "totals": _vm.totals,
      "totals-loading": _vm.loadGuestListStatus.pending
    },
    on: {
      "click-calendar": function ($event) {
        _vm.showAddToCalendar = true;
      },
      "click-guest-list": function ($event) {
        _vm.showGuestList = true;
      }
    }
  }), _c('v-divider'), _c('div', {
    staticClass: "pt-5 px-6 text-left"
  }, [_c('v-expand-transition', [_vm.tab == 0 ? _c('div', [_c('div', {
    staticClass: "title black--text"
  }, [_vm._v("Respond as")]), _vm.event.allowed == 'INVITED' ? _c('div', {
    class: {
      'error--text': !_vm.target
    }
  }, [_vm._v(" Responses for this event are only allowed from links sent via email / text ")]) : _vm._e(), _c('v-text-field', {
    staticClass: "my-3",
    attrs: {
      "hide-details": "",
      "placeholder": "Name",
      "outlined": "",
      "dense": "",
      "disabled": _vm.event.allowed == 'INVITED' && !_vm.target,
      "rules": [function (v) {
        return !!v;
      }]
    },
    model: {
      value: _vm.name,
      callback: function ($$v) {
        _vm.name = $$v;
      },
      expression: "name"
    }
  }), _vm.event.verify || _vm.event.allowed == 'INVITED' ? _c('v-text-field', {
    attrs: {
      "hide-details": "",
      "placeholder": "Email address / phone number",
      "outlined": "",
      "dense": "",
      "readonly": "",
      "disabled": _vm.event.allowed == 'INVITED',
      "value": _vm.target
    },
    on: {
      "click": function ($event) {
        _vm.showVerify = true;
      }
    }
  }) : _c('email-phone-field', {
    attrs: {
      "required": "",
      "hide-contacts": ""
    },
    model: {
      value: _vm.target,
      callback: function ($$v) {
        _vm.target = $$v;
      },
      expression: "target"
    }
  }), _c('div', {
    staticClass: "mt-9 text-right"
  }, [_c('v-btn', {
    staticClass: "pr-2",
    attrs: {
      "color": "primary",
      "disabled": !_vm.name || !_vm.target,
      "loading": _vm.loadExistingResponseStatus.pending
    },
    on: {
      "click": _vm.loadExistingResponse
    }
  }, [_vm._v(" Continue "), _c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1)], 1), _c('v-expand-transition', [_vm.previous ? _c('div', {
    staticClass: "pt-6 text--label-active font-italic text-right"
  }, [_vm._v(" Response for " + _vm._s(_vm._f("email-phone")(_vm.target)) + " last updated "), _c('span', {
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.previous.updated_at, 'short')))])]) : _vm._e()])], 1) : _vm._e()]), _c('v-expand-transition', [_vm.tab == 1 ? _c('div', [_c('div', [_c('v-btn', {
    staticClass: "pl-2",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.tab = 0;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronLeft)
    }
  }), _vm._v(" Respond as ")], 1)], 1), _vm.event.allowed == 'NONE' ? _c('div', {
    staticClass: "mt-9 warning--text font-italic"
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "warning"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiAlert)
    }
  }), _vm._v(" The host has closed responses for this event ")], 1) : _vm._e(), _c('v-form', {
    ref: "rsvp",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('form-rsvp', {
    staticClass: "text-left",
    attrs: {
      "form": _vm.event.form,
      "response": _vm.response,
      "disabled": _vm.saveStatus.pending || _vm.event.allowed == 'NONE'
    }
  })], 1), _vm.event.allowed != 'NONE' ? _c('div', {
    staticClass: "mt-9 text-right"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.saveStatus.pending
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(" " + _vm._s(_vm.previous ? 'Update' : 'Submit') + " ")])], 1) : _vm._e(), _vm.previous ? _c('div', {
    staticClass: "mt-6 text--label-active font-italic text-right"
  }, [_vm._v(" Response for " + _vm._s(_vm._f("email-phone")(_vm.target)) + " last updated "), _c('span', {
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.previous.updated_at, 'short')))])]) : _vm._e()], 1) : _vm._e()])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }